export default __webpack_public_path__ + "static/media/tiger.6b7c17a3.png";